<template>
    <div class="about-container">
        <div class="card-container">
            <!-- Logo -->
            <div class="logo-section">
                <img src="/logo.png" alt="羊驼考务" class="system-logo" onerror="this.style.display='none'" />
            </div>

            <el-divider>
                <h2 class="section-title">技术支持</h2>
            </el-divider>

            <!-- 联系方式卡片 -->
            <div class="contact-cards">
                <el-card class="contact-card" shadow="hover">
                    <div class="card-icon">
                        <i class="el-icon-message"></i>
                    </div>
                    <h3 class="card-title">邮件咨询</h3>
                    <p class="card-subtitle">最全面准确的沟通方式</p>
                    <p class="card-content">ask10060@qq.com</p>
                    <el-button type="primary" size="small" @click="sendEmail" icon="el-icon-message">
                        发送邮件
                    </el-button>
                </el-card>

                <el-card class="contact-card" shadow="hover">
                    <div class="card-icon">
                        <i class="el-icon-phone"></i>
                    </div>
                    <h3 class="card-title">电话咨询</h3>
                    <p class="card-subtitle">010-86379593(总机/30线并发呼入)</p>
                    <p class="card-subtitle">027-59769924(总机/30线并发呼入)</p>
                    <p class="card-content">
                        分机：7893(潘存熙)&nbsp;&nbsp;9503(马强)<br />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4616(刘德森)&nbsp;&nbsp;1924(陈盼)<br />
                        紧急技术故障电话会议室 95506(分机)
                    </p>
                </el-card>

                <el-card class="contact-card" shadow="hover">
                    <div class="card-icon">
                        <i class="el-icon-monitor"></i>
                    </div>
                    <h3 class="card-title">远程协助</h3>
                    <p class="card-subtitle">远程协助，方便便捷</p>
                    <p class="card-content">
                        <a href="https://file.yangtuokaowu.com/Image/ObjectFile/1241/637497581479577816.exe" 
                           target="_blank" 
                           class="download-link">
                            点击下载羊驼考务远程协助客户端
                        </a>
                    </p>
                    <p class="card-note">(技术人员将可远程操作该电脑)</p>
                    <p class="wechat-note">请随时通过微信支持群联络</p>
                </el-card>
            </div>

            <!-- 底部说明 -->
            <div class="footer-note">
                <p>我们非常重视您的反馈，这将是我们优化系统的重要参考内容。</p>
                <p>
                    <a href="mailto:ask10060@qq.com" class="feedback-link">
                        欢迎来信索取考试面试打分及笔试阅卷系统介绍册
                    </a>
                </p>
            </div>

            <el-divider></el-divider>

            <!-- 系统信息 -->
            <div class="system-info">
                <h3 class="info-title">系统信息</h3>
                <el-descriptions :column="2" border>
                    <el-descriptions-item label="系统名称">羊驼考务 - 招录管理系统</el-descriptions-item>
                    <el-descriptions-item label="版本号">v1.0.0</el-descriptions-item>
                    <el-descriptions-item label="技术支持">羊驼考务技术团队</el-descriptions-item>
                    <el-descriptions-item label="更新时间">2024年11月</el-descriptions-item>
                </el-descriptions>
            </div>

            <!-- 权限说明 -->
            <div class="permission-note">
                <el-alert
                    title="权限说明"
                    type="info"
                    :closable="false"
                    show-icon>
                    <template>
                        <p>管理员账号由上级系统统一管理，本系统只提供登录验证功能。</p>
                        <p>如需添加、修改或删除管理员，请联系上级系统管理员。</p>
                        <p>访问本系统需要以下权限：</p>
                        <ul>
                            <li>部门 (A_BuMen) = 2047</li>
                            <li>权限 (A_QiTaQuanXian) 包含 5008(招录系统管理员) 或 3001(超级管理员)</li>
                            <li>必须绑定院校代码 (A_BeiYong_5)</li>
                        </ul>
                    </template>
                </el-alert>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'About',
    methods: {
        sendEmail() {
            window.location.href = 'mailto:ask10060@qq.com';
        }
    }
};
</script>

<style scoped>
.about-container {
    max-width: 1200px;
    margin: 0 auto;
}

.logo-section {
    text-align: center;
    padding: 40px 0;
}

.system-logo {
    width: 110px;
    height: 110px;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.section-title {
    font-size: 28px;
    font-weight: 600;
    color: #303133;
    margin: 0;
}

.contact-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 24px;
    margin: 32px 0;
}

.contact-card {
    text-align: center;
    transition: transform 0.3s;
}

.contact-card:hover {
    transform: translateY(-5px);
}

.card-icon {
    font-size: 48px;
    color: #409EFF;
    margin-bottom: 16px;
}

.card-icon i {
    display: inline-block;
}

.card-title {
    font-size: 22px;
    font-weight: 600;
    color: #303133;
    margin: 16px 0 8px;
}

.card-subtitle {
    font-size: 14px;
    color: #909399;
    margin: 8px 0;
    line-height: 1.6;
}

.card-content {
    font-size: 14px;
    color: #606266;
    margin: 16px 0;
    line-height: 1.8;
    min-height: 80px;
}

.download-link {
    color: #409EFF;
    text-decoration: none;
    border-bottom: 1px dashed #409EFF;
}

.download-link:hover {
    color: #66b1ff;
    border-bottom-color: #66b1ff;
}

.card-note {
    font-size: 12px;
    color: #909399;
    margin-top: 8px;
}

.wechat-note {
    font-size: 14px;
    color: #777;
    margin-top: 12px;
}

.footer-note {
    text-align: center;
    padding: 32px 0;
    background-color: #f5f7fa;
    border-radius: 8px;
    margin: 32px 0;
}

.footer-note p {
    margin: 8px 0;
    color: #606266;
    line-height: 1.8;
}

.feedback-link {
    color: #409EFF;
    text-decoration: none;
}

.feedback-link:hover {
    text-decoration: underline;
}

.system-info {
    margin: 32px 0;
}

.info-title {
    font-size: 20px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 16px;
}

.permission-note {
    margin-top: 32px;
}

.permission-note >>> .el-alert__content {
    text-align: left;
}

.permission-note p {
    margin: 8px 0;
    line-height: 1.6;
}

.permission-note ul {
    margin: 12px 0 0 20px;
    padding: 0;
}

.permission-note li {
    margin: 8px 0;
    color: #606266;
    line-height: 1.6;
}

@media (max-width: 768px) {
    .contact-cards {
        grid-template-columns: 1fr;
    }

    .system-logo {
        width: 80px;
        height: 80px;
    }

    .section-title {
        font-size: 24px;
    }
}
</style>

